import { Component, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { Device } from '@capacitor/device';
import { PageComponent } from '@infodata-group/inf-commons-mobile';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'infl-page-device-informations',
  standalone: true,
  imports: [TranslatePipe, PageComponent],
  templateUrl: './page-device-informations.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-device-informations.component.scss',
})
export class PageDeviceInformationsComponent {
  private manufacturer = signal<string | null>(null);
  private model = signal<string | null>(null);
  private operatingSystem = signal<string | null>(null);
  private osVersion = signal<string | null>(null);
  private webviewVersion = signal<string | null>(null);

  protected informations = computed(() => {
    const informations = [];

    if (this.manufacturer() !== null) {
      informations.push({
        name: 'i18n.mobile.page.deviceInformations.manufacturer',
        value: this.manufacturer(),
      });
    }
    if (this.model() !== null) {
      informations.push({
        name: 'i18n.mobile.page.deviceInformations.model',
        value: this.model(),
      });
    }
    if (this.operatingSystem() !== null) {
      if (this.operatingSystem() === 'android') {
        informations.push({
          name: 'i18n.mobile.page.deviceInformations.operatingSystem',
          value: `${this.osVersion() ?? ''}`,
        });
      } else {
        informations.push({
          name: 'i18n.mobile.page.deviceInformations.operatingSystem',
          value: `${this.operatingSystem()} ${this.osVersion() ?? ''}`,
        });
      }
    }
    if (this.webviewVersion() !== null) {
      informations.push({
        name: 'i18n.mobile.page.deviceInformations.webviewVersion',
        value: this.webviewVersion(),
      });
    }

    return informations;
  });

  constructor() {
    const loadDeviceInformations = async () => {
      const deviceInformations = await Device.getInfo();
      this.manufacturer.set(deviceInformations.manufacturer ?? null);
      this.model.set(deviceInformations.model ?? null);
      this.operatingSystem.set(deviceInformations.operatingSystem ?? null);
      this.osVersion.set(deviceInformations.osVersion ?? null);
      this.webviewVersion.set(deviceInformations.webViewVersion ?? null);
    };

    loadDeviceInformations();
  }
}
